import React from "react";

import { getCustomization } from "@multiweb/customization";
import { TemplateLayoutItem, TemplateLayoutVariant } from "@multiweb/reactComponents";
import { IDataSourceAttribute } from "@multiweb/reactCore/datasource";
import { TypedObject } from "@multiweb/types/react";
import { Role } from "@multiweb/uiShared/Role";

/**
 * Vrací položky, které se mají umístit do řádku.
 *
 * @param attributeNames Jména atributů.
 * @param dataSourceKey Klíč k DataSource.
 * @param recordId Identifikátor záznamu.
 * @param dataSourceAttributes Načtené DataSource atributy.
 * @param variant Upravuje výchozí chování vzhledu.
 * @param role Role pro přístupnost.
 */
export const getItems = (
    attributeNames: ReadonlyArray<string>,
    dataSourceKey: string,
    recordId: string,
    dataSourceAttributes?: TypedObject<IDataSourceAttribute>,
    variant?: TemplateLayoutVariant,
    role?: Role,
): JSX.Element[] =>
    attributeNames.map((attributeName, index) => {
        const AttributeComponent = getCustomization().liteListFrame.attribute.getRendererByKey(
            dataSourceAttributes?.[attributeName]?.attributeRendererKey || "",
        ).component;
        return (
            <TemplateLayoutItem
                key={`${attributeName}-${index}`}
                qa={attributeName}
                content={<AttributeComponent {...{ dataSourceKey, recordId, attributeName }} />}
                extendedProperties={dataSourceAttributes?.[attributeName]?.extendedProperties}
                {...{ variant, role }}
            />
        );
    });
